<template>
  <div class="forParents">
    <Parallax />
    <ProblemsText />
    <Hope />
    <Reviewes />
    <Mentors />
    <RoadMap />
    <FAQ></FAQ>
    <CoursesSlider />
    <Courses/>    
    <!-- <StartPage class="startPage"></StartPage> -->
    <Discont/>  
  </div>
</template>

<script>
import RoadMap from "./RoadMap.vue";
import FAQ from "./Parents/FAQ.vue";
import Parallax from "./Parents/Parallax.vue";
import CoursesSlider from "./CoursesSlider.vue";
// import StartPage from "./StartPage.vue";
import ProblemsText from "./Parents/ProblemsText.vue";
import Hope from "./Parents/Hope.vue";
import Reviewes from "./Reviewes.vue";
import Mentors from "./Mentors.vue";
import Courses from"./Courses.vue"
import Discont from "./Discont.vue"

export default {
  components: {
    RoadMap,
    FAQ,
  
    Parallax,
    CoursesSlider,
    ProblemsText,
    Mentors,
    Hope,
    Reviewes,
    Courses,
    Discont
  },
};
</script>

<style lang="scss" scoped>
.forParents {
  overflow: hidden;
}
</style>